import React from 'react'
import { useSelector } from 'react-redux'
import { Row, Col } from 'antd'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import { WrapSectionHeader } from './styles'

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R5Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  if (!header.length) {
    return null
  }

  const defaultInfo = ' - '

  const totalCount = header[0].total_count || defaultInfo
  const totalSum = (
    <Text>
      {
        currencyMask({ formatStr: true, value: header[0].total_sum })
          .maskedValue
      }
    </Text>
  )
  const headerRequests = header[0].requests || defaultInfo
  const startedOn =
    moment
      .unix(header[0].started_on)
      .utc()
      .format('DD/MM/YYYY') || defaultInfo
  const endedOn =
    moment
      .unix(header[0].ended_on)
      .utc()
      .format('DD/MM/YYYY') || defaultInfo

  return (
    <WrapSectionHeader>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.5.header.requests">
            <span id="value">{headerRequests}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.5.header.started-on">
            <span id="value">{startedOn}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.5.header.total-count">
            <span id="value">{totalCount}</span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.5.header.ended-on">
            <span id="value">{endedOn}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.5.header.total-sum">
            <span id="value">{totalSum}</span>
          </Text>
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
